import { BaseDto } from "@/shared/dtos/base-dto";

export class changepwd extends BaseDto {
  public contra!: string;
  public nuevacontra!: string;
  public rptnuevacontra!: string;
}
